module.exports = __webpack_public_path__ + "img/new_index_industry_icon7.cc766dff.png";